import { type ReactNode } from 'react';
import { StyleSheet } from 'react-native';

import { PageBuilderRenderer } from '@fhs/page-builder';
import { ScrollView } from '@fhs/ui';

import { useActionHandler } from './use-action-handler';
import { useLoyaltyHomepageConfigQuery } from './use-loyalty-homepage-config-query';

export type LoyaltyHomepageProps = {
  legacyHomeCard: ReactNode;
};

export function LoyaltyHomepage(props: LoyaltyHomepageProps) {
  const { data: loyaltyHomepageConfigDocument } = useLoyaltyHomepageConfigQuery();
  const layout = loyaltyHomepageConfigDocument?.unauthenticatedUsers?.layout;
  const widgets = loyaltyHomepageConfigDocument?.unauthenticatedUsers?.widgets ?? [];

  const handleAction = useActionHandler();

  return (
    <ScrollView style={styles.scroller}>
      {layout && (
        <PageBuilderRenderer
          layout={layout}
          widgets={widgets}
          onAction={handleAction}
          legacyHomeCard={props.legacyHomeCard}
        />
      )}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scroller: {
    flexGrow: 1,
  },
});
